
// Import Vendors
import FarloUiLightbox from './vendors/farlo-ui-lightbox';
import FarloUiSelectBox from './vendors/farlo-ui-selectbox';
import FarloUiNumberInput from './vendors/farlo-ui-numberinput.js';
import FarloUiList from './vendors/farlo-ui-list.js';
import FarloUiRevolverCarousel from './vendors/farlo-ui-revolver-carousel';
import FarloUiTicketCalendar from './vendors/farlo-ui-ticket-calendar';
import addLightboxToGallery from './vendors/farlo-ui-gallery-lightbox.js';

// Import Footer Components
import { farloUiCrmSignup } from './components/footer/farloUiCrmSignup.js';
import { elementInView } from './components/footer/elementInView.js';
import { toggleFAQ } from './components/footer/toggleFAQ.js';
import { faqs } from './components/footer/faqs.js';
import { smoothScrollToAnchor, handleInitialHash } from './components/footer/smoothScrollToAnchor.js';
import { embedOverlay } from './components/footer/embedOverlay.js';
import { mapLoader } from './components/footer/mapLoader.js';
import { handleSubMenu } from './components/footer/handleSubMenu.js';
import { getTallestSubMenu, navicon, searchIcon, navigation } from './components/footer/navigation.js';
import { flickityPagination } from './components/footer/flickityPagination.js';
import { farloCrmToggle } from './components/footer/farloCrmToggle.js';
import { addScrolledClass } from './components/footer/addScrolledClass.js';
import { parralaxBlock } from './components/footer/parralaxBlock.js';
import { scrollingText } from './components/footer/scrollingText.js';
import { historySlider } from './components/footer/historySlider.js';
import { farloShare } from './components/footer/farloShare.js';
import { searchInput } from './components/footer/searchInput.js';
import { reviewSliderInit } from './components/footer/reviewSlider.js';
import { socialFeedSlider } from './components/footer/socialFeedSlider.js';
import { faqSearchInput } from './components/footer/faqSearchInput.js';
import { faqReturnToTop } from './components/footer/faqReturnToTop.js';
import { noticeBanner } from './components/footer/noticeBanner.js';
import { copyLink } from './components/footer/copyLink.js';
import { initFlickitySlider } from './components/footer/initFlickitySlider.js';
import { searchAjax } from './components/footer/searchAjax.js';
import { showFinderAjax } from './components/footer/showFinderAjax.js';
import { multiSelect } from './components/footer/multiSelect.js';
import { showSlider } from './components/footer/showSlider.js';
import { farloUiDrawer } from './components/footer/farloUIDrawer.js';
import { autismPerformanceSlider } from './components/footer/autismPerformanceSlider.js';
import { legacyQueryShowfinder } from './components/footer/legacyQueryShowfinder.js';
import { breadcrumbDropdown } from './components/footer/breadcrumbDropdown.js';
import { gravityFormsSubmit } from './components/footer/gravityFormsSubmit.js';
import { sliderMobile } from './components/footer/sliderMobile.js';

((document, window, history) => {
	const pushState = history.pushState;

	history.pushState = function(state) {
		if (typeof history.onpushstate === 'function') {
			history.onpushstate({ state });
		}
		return pushState.apply(history, arguments);
	};

	document.addEventListener('DOMContentLoaded', () => {
		// Handle initial hash in URL for smooth scrolling to anchors on page load
		handleInitialHash();

		// Initialize Gravity Forms submit handler
		gravityFormsSubmit();

		if (document.querySelector('.farlo-ui-masthead__breadcrumbs')) breadcrumbDropdown();
    	if (document.querySelector('.site-navigation__navicon')) navicon();
        if (document.querySelector('.site-header')) addScrolledClass();
        if (document.querySelector('.site-navigation__primary__sub-menu')) getTallestSubMenu();
		if (document.querySelector('.site-navigation__primary__sub-menu')) {
			document
				.querySelectorAll('.site-navigation__primary__sub-menu')
				.forEach((_sel) => {
					navigation(_sel);
				});
		}

		if (document.querySelector('.farlo-share-widget')){
			farloShare();
		}

		if (document.querySelector('.is-style-slider')){
			  const sliders = document.querySelectorAll('.is-style-slider');
				if (sliders.length) {
					sliders.forEach(slider => {
					const alignment = slider.getAttribute('data-alignment') || 'center';
					initFlickitySlider(slider, alignment);
					});
				}
		}

		if (document.querySelector('.is-style-slider-mobile')){
			sliderMobile();
		}

		if (document.querySelector('.related-performances__carousel')){
			  const sliders = document.querySelectorAll('.related-performances__carousel');
				if (sliders.length) {
					sliders.forEach(slider => {
					const buttonStyling = slider.getAttribute('data-buttons') || 'default';
					initFlickitySlider(slider, buttonStyling);
					});
				}
		}

		if (document.querySelector('.farlo-ui-drawer')){
			  const drawers = document.querySelectorAll('.farlo-ui-drawer');
				if (drawers.length) {
					drawers.forEach(drawer => {
					farloUiDrawer(drawer);
					});
				}
		}

		if (document.querySelector('.farlo-share-widget__copy-link')){
			copyLink();
		}

		if (document.querySelector('.farlo-ui-list-shows__shows--slider')){
			const showSliders = document.querySelectorAll('.farlo-ui-list-shows__shows--slider');
			showSliders.forEach((sliderEl) => {
				const buttonPosition = sliderEl.getAttribute('data-buttons') || 'below';
				showSlider(sliderEl, {}, buttonPosition);
			});
		}

		if (document.querySelector('.farlo-ui-faq')){
			faqSearchInput();
			faqReturnToTop();
		}

		if (document.querySelector('.farlo-ui-reviews')) {
		const reviewSliders = document.querySelectorAll('.farlo-ui-reviews__list');
		reviewSliders.forEach((sliderEl) => {
			const buttonPosition = sliderEl.getAttribute('data-buttons') || 'below';
			reviewSliderInit(sliderEl, {}, buttonPosition);
		});
		}

		if (document.querySelector('.search-results')){
			searchAjax();
		}

		if (document.querySelector('.farlo-ui-show-finder')){
			  const root = document.querySelector('[data-sf-root]');
			const form = root?.querySelector('form');
			if (form) applyLegacyQueryToForm(form);
			showFinderAjax();
			 multiSelect();
		}

		if (document.querySelector('.farlo-ui-social-feed')){
			socialFeedSlider('.farlo-ui-social-feed');
		}


		if (document.querySelector('.farlo-ui-search-bar')){
			searchInput();
		}

		if (document.querySelector('.farlo-ui-parralax')){
			parralaxBlock();
		}

		if (document.querySelector('.farlo-ui-scrolling-text')){
			scrollingText();
		}

		if (document.querySelector('.farlo-ui-slider-masthead')){
			flickityPagination();
		}

		if (document.querySelector('.history-slider')){
			historySlider();
		}

		if (document.querySelector('.farlo-ui-crm--inline')) {
			document.querySelectorAll('[farlo-ui="crm"]').forEach((_sel) => {
				farloUiCrmSignup(_sel);
			});
		}

		if (document.querySelector('.is-style-lightbox-gallery')) {
			addLightboxToGallery();
		}

		if (document.querySelectorAll('.wp-block-embed')) {
			embedOverlay();
		}

		if (document.querySelector('.farlo-ui-crm__toggle')) {
			farloCrmToggle();
		}

		if (document.querySelector('.farlo-ui-map')) {
			mapLoader();
		}

		if (document.querySelector('.farlo-ui-notice-banner')){
			noticeBanner();
		}

		document.querySelectorAll('a[href*="#"]').forEach((_sel) => {
			smoothScrollToAnchor(_sel);
		});

		if (document.querySelector('.farlo-ui-accordion .rank-math-list-item')) {
			document.querySelectorAll('.rank-math-question').forEach((_el) => {
				_el.dataset.toggled = '0';
				_el.addEventListener('click', () => {
					toggleFAQ(_el);
				});
			});
		}

		if (document.querySelector('#rank-math-faq .rank-math-list-item')) {
			document.querySelectorAll('#rank-math-faq .rank-math-list-item .rank-math-question').forEach((_el) => {
				_el.dataset.toggled = '0';
				_el.addEventListener('click', () => {
					toggleFAQ(_el);
				});
			});
		}

		if (document.querySelector('.site-faqs')) {
			faqs();
		}

		if (document.querySelector('.farlo-ui-animated')) {
			document.querySelectorAll('.farlo-ui-animated').forEach((_sel) => {
				elementInView(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-ticket-calendar')) {
			document.querySelectorAll('[farlo-ui="calendar"]').forEach((_sel) => {
				new FarloUiTicketCalendar(_sel);
			});
		}

		if (document.querySelector('select')) {
			document.querySelectorAll('select').forEach((_sel) => {
				new FarloUiSelectBox(_sel);
			});
		}
		if (document.querySelector('input[type="number"]')) {
			document.querySelectorAll('input[type="number"]').forEach((numberInput) => {
				new FarloUiNumberInput(numberInput);
			});
		}

		if (document.querySelector('.gfield_list_icons')) {
			document.querySelectorAll('.gfield_list_icons').forEach(function(buttonContainer) {
				new FarloUiList(buttonContainer);
			});
		}

		if (document.querySelector('.farlo-ui-lightbox__toggle')) {
			document.querySelectorAll('.farlo-ui-lightbox__toggle').forEach((_sel) => {
				new FarloUiLightbox(_sel);
			});
		}

		if (document.querySelector('.farlo-ui-revolver-carousel')) {
			document.querySelectorAll('[farlo-ui="carousel"]').forEach((_sel) => {
				new FarloUiRevolverCarousel(_sel);
			});
		}
	});

	if (typeof navigator !== 'undefined' && navigator.serviceWorker) {
		navigator.serviceWorker.getRegistrations().then(function(registrations) {
			for (const registration of registrations) {
				registration.unregister();
			}
		});
	}
})(document, window, history);
